module.exports = __webpack_public_path__ + "media/images/about_us/about-us-a84540be26151ec68667705098dd170b.jpg";